"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetX = exports.collapseBox = void 0;
const collapseBox = (box) => {
    return `${box.top} ${box.right} ${box.bottom} ${box.left}`;
};
exports.collapseBox = collapseBox;
/**
 * Get offset margins to contain element within a container
 * @param rect bounding client rect of element (relative coords of element based on container)
 * @param offsetWidth offsetWidth of element (element width)
 * @param maxWidth offsetWidth of container (container width)
 * @returns Box containing margins
 */
const getOffsetX = (rect, offsetWidth, maxWidth) => {
    const margins = {
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    };
    // if overflows to the left
    if (rect.left < 0) {
        // offset by how much left it is overflowing
        margins.left = `${rect.left * -1}px`;
    }
    // if overflows to the right
    if (rect.right > maxWidth) {
        // offset by how much right it is overflowing
        margins.right = `${rect.right - maxWidth}px`;
    }
    return margins;
};
exports.getOffsetX = getOffsetX;
